import {axios, HOST, config} from './settiing';

export default {
  getNoticeList() {
    return axios.get(`${HOST}/manage/noticeList`, config);
  },
  getNotice(noticeId) {
    return axios.get(`${HOST}/manage/notice/${noticeId}`, config)
  },
  addNotice(data){
    return axios.post(`${HOST}/manage/notice`, data, config);
  },
  updateNotice(data){
    return axios.put(`${HOST}/manage/notice`, data, config);
  },
  deleteNotice(data){
    return axios.delete(`${HOST}/manage/notice/${data}`, config);
  }
}